import { Controller } from "@hotwired/stimulus"

// Lightweight dropdown menu (open/close + click-outside-to-close).
//
// The admin portal runs on Turbolinks (not Turbo), so we cannot rely on any
// Turbo-driven popover behaviour. This controller toggles a `hidden` class on
// the menu target and closes on outside click or Escape.
//
// Markup pattern:
//   <div data-controller="dropdown" class="relative">
//     <button data-action="dropdown#toggle">⋯</button>
//     <div data-dropdown-target="menu" class="hidden">…items…</div>
//   </div>
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._onOutsideClick = this._onOutsideClick.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    this._removeGlobalListeners()
  }

  toggle(event) {
    if (event) event.preventDefault()
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this._onOutsideClick, true)
    document.addEventListener("keydown", this._onKeydown, true)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this._removeGlobalListeners()
  }

  _onOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  _removeGlobalListeners() {
    document.removeEventListener("click", this._onOutsideClick, true)
    document.removeEventListener("keydown", this._onKeydown, true)
  }
}
